/* Mimi Marmo — small progressive enhancements. Everything degrades gracefully. */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal-on-view: adds .mm-inview when an element enters the viewport.
     Used for the script signature write-on and soft fades. bindReveals can
     be re-run after the DOM changes (e.g. facet filtering re-renders the
     collection grid) — already-bound elements are skipped. */
  var revealIO = null;

  function bindReveals(root) {
    var targets = (root || document).querySelectorAll('[data-mm-reveal]:not([data-mm-bound])');
    targets.forEach(function (el) {
      el.setAttribute('data-mm-bound', '');
      if (revealIO) {
        revealIO.observe(el);
      } else {
        el.classList.add('mm-inview');
      }
    });
  }

  function initReveals() {
    if ('IntersectionObserver' in window && !reducedMotion) {
      revealIO = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('mm-inview');
              revealIO.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -12% 0px', threshold: 0.15 }
      );
    }
    bindReveals(document);
  }

  /* Gentle parallax: elements with [data-mm-parallax] drift as they cross
     the viewport. Strength is a fraction of the scroll distance. The element
     list can be refreshed after DOM re-renders. */
  var parallaxEls = [];
  var parallaxTicking = false;

  function collectParallax() {
    parallaxEls = Array.prototype.slice.call(document.querySelectorAll('[data-mm-parallax]'));
  }

  function updateParallax() {
    var vh = window.innerHeight;
    parallaxEls.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) return;
      var strength = parseFloat(el.dataset.mmParallax) || 0.12;
      var progress = (rect.top + rect.height / 2 - vh / 2) / vh; /* -0.5 … 0.5-ish */
      el.style.transform = 'translateY(' + (progress * strength * 100).toFixed(2) + 'px) scale(1.12)';
    });
    parallaxTicking = false;
  }

  function requestParallax() {
    if (!parallaxTicking) {
      parallaxTicking = true;
      requestAnimationFrame(updateParallax);
    }
  }

  function refreshParallax() {
    if (reducedMotion) return;
    collectParallax();
    requestParallax();
  }

  function initParallax() {
    if (reducedMotion) return;
    collectParallax();
    window.addEventListener('scroll', requestParallax, { passive: true });
    window.addEventListener('resize', requestParallax);
    updateParallax();
  }

  /* Hero slideshow: ambient crossfade between slides, with the text and
     footnote caption swapping in sync with each photograph. */
  function initHeroSlider() {
    document.querySelectorAll('.mm-hero').forEach(function (hero) {
      var slides = hero.querySelectorAll('.mm-hero__slide');
      var texts = hero.querySelectorAll('.mm-hero__text');
      var footLabel = hero.querySelector('.mm-hero__foot-label');
      if (slides.length < 2) return;
      var current = 0;
      var timer = null;
      var dots = [];

      function show(next) {
        slides[current].classList.remove('is-active');
        slides[next].classList.add('is-active');
        if (dots[current] && dots[next]) {
          dots[current].classList.remove('is-active');
          dots[current].removeAttribute('aria-current');
          dots[next].classList.add('is-active');
          dots[next].setAttribute('aria-current', 'true');
        }
        if (texts[current] && texts[next]) {
          texts[current].classList.remove('is-active');
          texts[current].setAttribute('aria-hidden', 'true');
          texts[next].classList.add('is-active');
          texts[next].removeAttribute('aria-hidden');
          var footnote = texts[next].dataset.footnote;
          if (footLabel && footnote && footLabel.textContent.trim() !== footnote) {
            footLabel.classList.add('is-swapping');
            setTimeout(function () {
              footLabel.textContent = footnote;
              footLabel.classList.remove('is-swapping');
            }, 350);
          }
        }
        current = next;
      }

      function restart() {
        if (reducedMotion) return;
        if (timer) clearInterval(timer);
        timer = setInterval(function () {
          show((current + 1) % slides.length);
        }, 6500);
      }

      /* slide indicator dots — tappable, and they reset the autoplay clock */
      var rail = document.createElement('div');
      rail.className = 'mm-hero__dots';
      rail.setAttribute('role', 'group');
      rail.setAttribute('aria-label', 'Slides');
      Array.prototype.forEach.call(slides, function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'mm-hero__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Show slide ' + (i + 1) + ' of ' + slides.length);
        if (i === 0) dot.setAttribute('aria-current', 'true');
        dot.addEventListener('click', function () {
          if (i !== current) show(i);
          restart();
        });
        rail.appendChild(dot);
        dots.push(dot);
      });
      var inner = hero.querySelector('.mm-hero__inner');
      if (inner) inner.appendChild(rail);

      restart();
    });
  }

  /* Product page: show the sticky buy bar once the main buy buttons
     have scrolled out of view. */
  function initStickyBuyBar() {
    var bar = document.querySelector('.mm-sticky-buy');
    var anchor = document.querySelector('.product-form__submit');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var button = bar.querySelector('.mm-sticky-buy__btn');
    var shown = null;
    function setVisible(visible) {
      if (visible === shown) return;
      shown = visible;
      bar.classList.toggle('mm-sticky-buy--visible', visible);
      /* expose the bar to assistive tech and the tab order only while shown */
      bar.setAttribute('aria-hidden', String(!visible));
      if (button) button.tabIndex = visible ? 0 : -1;
      document.body.classList.toggle('mm-has-sticky-buy', visible);
    }
    var io = new IntersectionObserver(
      function (entries) {
        setVisible(!entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      },
      { threshold: 0 }
    );
    io.observe(anchor);

    /* iOS Safari can defer observer callbacks through a fling or a tap on the
       status bar, leaving the bar up at the top of the page — reconcile from
       the real geometry whenever scrolling settles */
    var ticking = false;
    function reconcile() {
      ticking = false;
      var rect = anchor.getBoundingClientRect();
      setVisible(rect.bottom < 0);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(reconcile);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('scrollend', reconcile);
  }

  /* Variant picker extras — all event-delegated, because product-info.js
     replaces the whole <variant-selects> element on every variant change. */

  function metalTone(value) {
    var v = (value || '').toLowerCase();
    if (v.indexOf('white') !== -1 || v.indexOf('silver') !== -1 || v.indexOf('platinum') !== -1) return 'white';
    if (v.indexOf('rose') !== -1 || v.indexOf('pink') !== -1) return 'rose';
    return 'yellow';
  }

  function crossfadeText(el, text) {
    if (!el || el.textContent.trim() === (text || '').trim()) return;
    if (reducedMotion) {
      el.textContent = text;
      return;
    }
    el.classList.add('is-swapping');
    setTimeout(function () {
      el.textContent = text;
      el.classList.remove('is-swapping');
    }, 250);
  }

  function initVariantExtras() {
    /* size guide drawer */
    document.addEventListener('click', function (event) {
      var btn = event.target.closest('.mm-size-guide__toggle');
      if (!btn) return;
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      var open = panel.hasAttribute('hidden');
      if (open) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.matches || !input.matches('.mm-options input[type="radio"]')) return;

      /* keep the legend's italic selected-value in sync */
      var fieldset = input.closest('fieldset');
      var label = fieldset && fieldset.querySelector('[data-selected-value]');
      if (label) crossfadeText(label, input.value);

      /* metal change: retint every drawn visualizer right away (the Liquid
         re-render will confirm the same tone a moment later) */
      if (input.classList.contains('mm-metal__input')) {
        var tone = metalTone(input.value);
        var picker = input.closest('.mm-options') || document;
        picker.querySelectorAll('[data-mm-drape], [data-mm-ring], [data-mm-fit]').forEach(function (viz) {
          viz.setAttribute('data-mm-tone', tone);
        });
        /* the engraving atelier's metal preview lives outside variant-selects */
        document.querySelectorAll('[data-mm-atelier-stage]').forEach(function (stage) {
          stage.dataset.tone = tone;
        });
      }

      /* drape visualizer: light up the chosen chain arc + caption */
      if (input.classList.contains('mm-drape__input')) {
        var drape = input.closest('[data-mm-drape]');
        if (drape) {
          var index = input.dataset.drapeIndex;
          drape.querySelectorAll('[data-drape-gold]').forEach(function (arc) {
            arc.classList.toggle('is-active', arc.dataset.drapeGold === index);
          });
          drape.querySelectorAll('[data-drape-gem]').forEach(function (gem) {
            gem.classList.toggle('is-active', gem.dataset.drapeGem === index);
          });
          crossfadeText(drape.querySelector('[data-drape-caption-target]'), input.dataset.drapeCaption || '');
        }
      }

      /* true-size ring band: breathe to the new diameter + refresh readings */
      if (input.classList.contains('mm-ring__input')) {
        var ring = input.closest('[data-mm-ring]');
        if (ring) {
          ring.style.setProperty('--mm-ring-d', input.dataset.ringD);
          crossfadeText(ring.querySelector('[data-mm-ring-numeral]'), input.value);
          crossfadeText(ring.querySelector('[data-mm-ring-mm]'), input.dataset.ringMm || '');
          crossfadeText(ring.querySelector('[data-mm-ring-caption-target]'), input.dataset.ringCaption || '');
          var ringSpark = ring.querySelector('[data-mm-ring-spark]');
          if (ringSpark && !reducedMotion) {
            ringSpark.classList.remove('is-glint');
            void ringSpark.getBoundingClientRect(); /* restart the glint */
            ringSpark.classList.add('is-glint');
          }
        }
      }

      /* wrist wrap: light up the chosen bracelet arc + caption */
      if (input.classList.contains('mm-fit__input')) {
        var fit = input.closest('[data-mm-fit]');
        if (fit) {
          var fitIndex = input.dataset.fitIndex;
          fit.querySelectorAll('[data-fit-gold]').forEach(function (arc) {
            arc.classList.toggle('is-active', arc.dataset.fitGold === fitIndex);
          });
          fit.querySelectorAll('[data-fit-gem]').forEach(function (gem) {
            gem.classList.toggle('is-active', gem.dataset.fitGem === fitIndex);
          });
          crossfadeText(fit.querySelector('[data-fit-caption-target]'), input.dataset.fitCaption || '');
        }
      }

      /* stone on leather: recolor the drawn composition + script caption */
      var isStone = input.classList.contains('mm-stone__input');
      var isLeather = input.classList.contains('mm-leather__input');
      if (isStone || isLeather) {
        var picker2 = input.closest('.mm-options') || document;
        var stage = picker2.querySelector('[data-mm-compose]');
        if (isStone) {
          var stoneFs = input.closest('fieldset');
          if (stoneFs) crossfadeText(stoneFs.querySelector('[data-stone-caption-target]'), input.dataset.stoneCaption || '');
        }
        if (stage) {
          if (isStone) {
            stage.setAttribute('data-mm-stone', input.dataset.stoneKey || 'gem');
            stage.dataset.stoneName = input.value;
          } else {
            stage.setAttribute('data-mm-leather', input.dataset.leatherKey || 'brown');
            stage.dataset.leatherName = input.value;
          }
          var stoneName = stage.dataset.stoneName || '';
          var leatherName = stage.dataset.leatherName || '';
          var line = stoneName && leatherName
            ? stoneName + ' on ' + leatherName.toLowerCase() + ' leather'
            : stoneName || (leatherName + ' leather');
          crossfadeText(stage.querySelector('[data-mm-compose-caption]'), line);
          var spark = stage.querySelector('[data-mm-compose-spark]');
          if (spark && !reducedMotion) {
            spark.classList.remove('is-glint');
            void spark.getBoundingClientRect();
            spark.classList.add('is-glint');
          }
        }
      }

      updateStickyMeta();
    });
  }

  /* The engraving atelier (PDP): a toggle row unfolds into a live preview
     shaped like the piece — pendant disc, clasp bar, or the inside of a
     ring band with the word set on a curve. The text input + lettering
     radios are tied to the product form via the form attribute, so the
     regular add-to-cart FormData submit carries them as line item
     properties. Handlers are delegated for consistency with the rest of
     the PDP, though the block itself survives variant re-renders. */
  function initEngravingAtelier() {
    function refresh(root, etch) {
      var input = root.querySelector('[data-mm-atelier-input]');
      var word = root.querySelector('[data-mm-atelier-word]');
      var stage = root.querySelector('[data-mm-atelier-stage]');
      if (!input || !word || !stage) return;

      /* for the ring band the word lives in a <textPath>; classes and
         measurements belong to its parent <text> */
      var host = word.closest && word.closest('text') ? word.closest('text') : word;

      var value = input.value.replace(/\s+/g, ' ').trim();
      word.textContent = value || root.dataset.mmAtelierGhost || 'your word';
      host.classList.toggle('is-ghost', value === '');

      /* shrink the lettering until it fits its surface */
      stage.style.setProperty('--mm-atelier-scale', '1');
      var scale = 1;
      var arc = stage.querySelector('[data-mm-atelier-arc]');
      if (arc && host.getComputedTextLength) {
        var arcMax = arc.getTotalLength() * 0.92;
        var arcLen = host.getComputedTextLength();
        if (arcLen > arcMax) scale = Math.max(arcMax / arcLen, 0.3);
      } else if (host.parentElement) {
        var room = host.parentElement.clientWidth * (stage.dataset.shape === 'bar' ? 0.82 : 0.72);
        if (host.scrollWidth > room) scale = Math.max(room / host.scrollWidth, 0.3);
      }
      stage.style.setProperty('--mm-atelier-scale', scale.toFixed(3));

      var count = root.querySelector('[data-mm-atelier-count]');
      if (count) count.textContent = input.value.length + ' / ' + (input.getAttribute('maxlength') || '');

      if (etch && !reducedMotion) {
        host.classList.remove('is-etch');
        void host.getBoundingClientRect(); /* restart the etch-in animation */
        host.classList.add('is-etch');
      }
    }

    function setActive(root, on) {
      var panel = root.querySelector('[data-mm-atelier-panel]');
      if (panel) {
        if (on) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      }
      root.querySelectorAll('[data-mm-atelier-input], [data-mm-atelier-style]').forEach(function (el) {
        el.disabled = !on;
      });
      if (on) {
        refresh(root, false); /* measure only once the panel is visible */
        var input = root.querySelector('[data-mm-atelier-input]');
        if (input) input.focus({ preventScroll: true });
      }
    }

    document.addEventListener('change', function (event) {
      if (!event.target.closest) return;
      var toggle = event.target.closest('[data-mm-atelier-toggle]');
      if (toggle) {
        setActive(toggle.closest('[data-mm-atelier]'), toggle.checked);
        return;
      }
      var style = event.target.closest('[data-mm-atelier-style]');
      if (style) {
        var root = style.closest('[data-mm-atelier]');
        var stage = root.querySelector('[data-mm-atelier-stage]');
        if (stage) stage.dataset.style = style.value.toLowerCase();
        refresh(root, true);
      }
    });

    document.addEventListener('input', function (event) {
      if (!event.target.matches || !event.target.matches('[data-mm-atelier-input]')) return;
      refresh(event.target.closest('[data-mm-atelier]'), true);
    });

    /* phones: when the keyboard rises, keep the input and the engraving
       preview in the visible half of the screen */
    document.addEventListener('focusin', function (event) {
      if (!event.target.matches || !event.target.matches('[data-mm-atelier-input]')) return;
      if (window.matchMedia('(min-width: 750px)').matches) return;
      setTimeout(function () {
        event.target.scrollIntoView({ block: 'center', behavior: reducedMotion ? 'auto' : 'smooth' });
      }, 300);
    });

    /* nothing half-finished reaches the cart: an empty or switched-off
       engraving is dropped from the form just before submit */
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form.getAttribute || form.getAttribute('data-type') !== 'add-to-cart-form') return;
        document.querySelectorAll('[data-mm-atelier]').forEach(function (root) {
          var input = root.querySelector('[data-mm-atelier-input]');
          var toggle = root.querySelector('[data-mm-atelier-toggle]');
          if (!input || input.getAttribute('form') !== form.getAttribute('id')) return;
          input.value = input.value.replace(/\s+/g, ' ').trim();
          var active = !!(toggle && toggle.checked && input.value !== '');
          input.disabled = !active;
          root.querySelectorAll('[data-mm-atelier-style]').forEach(function (el) {
            el.disabled = !active;
          });
        });
      },
      true
    );

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        document.querySelectorAll('[data-mm-atelier]').forEach(function (root) {
          if (root.querySelector('[data-mm-atelier-panel]:not([hidden])')) refresh(root, false);
        });
      });
    }
  }

  /* Sticky bar: mirror the selected options + metal swatch */
  function updateStickyMeta() {
    var bar = document.querySelector('.mm-sticky-buy');
    if (!bar) return;
    var options = document.querySelector('.mm-options');
    var variantEl = bar.querySelector('[data-mm-sticky-variant]');
    var swatchEl = bar.querySelector('[data-mm-sticky-swatch]');
    if (options && variantEl) {
      var values = [];
      options.querySelectorAll('fieldset, .product-form__input--dropdown').forEach(function (group) {
        var checked = group.querySelector('input[type="radio"]:checked');
        if (checked) {
          values.push(checked.value);
        } else {
          var select = group.querySelector('select');
          if (select) values.push(select.value);
        }
      });
      if (values.length) variantEl.textContent = values.join(' · ');
    }
    if (swatchEl) {
      var metal = document.querySelector('.mm-metal__input:checked');
      var stoneInput = document.querySelector('.mm-stone__input:checked');
      if (metal) {
        swatchEl.setAttribute('data-mm-tone', metalTone(metal.value));
        swatchEl.removeAttribute('hidden');
      } else if (stoneInput) {
        /* stone-on-leather pieces: the sticky chip shows the chosen stone */
        swatchEl.setAttribute('data-mm-stone', stoneInput.dataset.stoneKey || 'gem');
        swatchEl.removeAttribute('hidden');
      }
    }
  }

  /* Sticky bar price shadows the main price block, which product-info.js
     re-renders on variant change. */
  function initStickyPriceMirror() {
    var bar = document.querySelector('.mm-sticky-buy');
    var price = document.querySelector('product-info [id^="price-"]');
    if (!bar || !price || !('MutationObserver' in window)) return;
    var target = bar.querySelector('[data-mm-sticky-price]');
    if (!target) return;

    function readPrice() {
      var container = price.querySelector('.price');
      if (!container) return;
      var item = container.classList.contains('price--on-sale')
        ? container.querySelector('.price__sale .price-item--sale')
        : container.querySelector('.price__regular .price-item--regular');
      if (item) target.textContent = item.textContent.trim();
    }

    new MutationObserver(readPrice).observe(price, { childList: true, subtree: true, characterData: true });
    readPrice();
  }

  /* Roman numerals for elegant counts (lightbox counter, collection
     piece counts, pagination). The product gallery has its own copy
     in media-gallery.js. */
  function roman(n) {
    var map = [
      [1000, 'M'], [900, 'CM'], [500, 'D'], [400, 'CD'],
      [100, 'C'], [90, 'XC'], [50, 'L'], [40, 'XL'],
      [10, 'X'], [9, 'IX'], [5, 'V'], [4, 'IV'], [1, 'I']
    ];
    var out = '';
    map.forEach(function (pair) {
      while (n >= pair[0]) {
        out += pair[1];
        n -= pair[0];
      }
    });
    return out || 'I';
  }

  /* Lightbox 2.0 — one image at a time with arrows, a roman counter,
     keyboard navigation and click-to-zoom with pointer panning. */
  function initLightbox() {
    document.querySelectorAll('product-modal').forEach(function (modal) {
      var content = modal.querySelector('.product-media-modal__content');
      if (!content) return;

      function items() {
        return Array.prototype.slice.call(content.querySelectorAll(':scope > [data-media-id]'));
      }

      function resetZoom() {
        modal.classList.remove('mm-lb-zoomed');
        content.querySelectorAll('img.is-zoomed').forEach(function (img) {
          img.classList.remove('is-zoomed');
          img.style.transformOrigin = '';
        });
      }

      function updateCounter() {
        var counter = modal.querySelector('[data-mm-lb-counter]');
        if (!counter) return;
        var nodes = items();
        var index = 0;
        nodes.forEach(function (el, i) {
          if (el.classList.contains('active')) index = i;
        });
        var current = counter.querySelector('[data-mm-lb-current]');
        var sum = counter.querySelector('[data-mm-lb-sum]');
        if (current) current.textContent = roman(index + 1);
        if (sum) sum.textContent = roman(nodes.length);
      }

      function step(dir) {
        var nodes = items();
        if (nodes.length < 2) return;
        var index = 0;
        nodes.forEach(function (el, i) {
          if (el.classList.contains('active')) index = i;
        });
        var next = (index + dir + nodes.length) % nodes.length;
        nodes.forEach(function (el, i) {
          el.classList.toggle('active', i === next);
        });
        resetZoom();
        updateCounter();
        window.pauseAllMedia && window.pauseAllMedia();
      }

      modal.querySelectorAll('[data-mm-lb-nav]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          step(parseInt(btn.dataset.mmLbNav, 10) || 1);
        });
      });

      modal.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') step(1);
        if (event.key === 'ArrowLeft') step(-1);
      });

      /* counter + fresh zoom state whenever the modal opens */
      if ('MutationObserver' in window) {
        new MutationObserver(function () {
          if (modal.hasAttribute('open')) {
            resetZoom();
            updateCounter();
            modal.classList.remove('mm-lb-visited');
          }
        }).observe(modal, { attributes: true, attributeFilter: ['open'] });
      }

      /* click-to-zoom with pointer panning */
      function setOrigin(event) {
        var img = content.querySelector('img.active.is-zoomed');
        if (!img) return;
        var rect = content.getBoundingClientRect();
        var x = Math.min(Math.max(((event.clientX - rect.left) / rect.width) * 100, 0), 100);
        var y = Math.min(Math.max(((event.clientY - rect.top) / rect.height) * 100, 0), 100);
        img.style.transformOrigin = x + '% ' + y + '%';
      }

      content.addEventListener('click', function (event) {
        var img = event.target.closest('img[data-media-id]');
        if (!img || !img.classList.contains('active')) return;
        var zoomIn = !img.classList.contains('is-zoomed');
        if (zoomIn) {
          var rect = content.getBoundingClientRect();
          var x = Math.min(Math.max(((event.clientX - rect.left) / rect.width) * 100, 0), 100);
          var y = Math.min(Math.max(((event.clientY - rect.top) / rect.height) * 100, 0), 100);
          img.style.transformOrigin = x + '% ' + y + '%';
          img.classList.add('is-zoomed');
          modal.classList.add('mm-lb-zoomed', 'mm-lb-visited');
        } else {
          resetZoom();
        }
      });

      content.addEventListener('pointermove', function (event) {
        if (modal.classList.contains('mm-lb-zoomed')) setOrigin(event);
      });

      /* touch: swipe horizontally between plates while not zoomed */
      var touchX = null;
      var touchY = null;
      content.addEventListener(
        'touchstart',
        function (event) {
          if (event.touches.length !== 1 || modal.classList.contains('mm-lb-zoomed')) {
            touchX = touchY = null;
            return;
          }
          touchX = event.touches[0].clientX;
          touchY = event.touches[0].clientY;
        },
        { passive: true }
      );
      content.addEventListener(
        'touchend',
        function (event) {
          if (touchX === null || modal.classList.contains('mm-lb-zoomed')) return;
          var dx = event.changedTouches[0].clientX - touchX;
          var dy = event.changedTouches[0].clientY - touchY;
          touchX = touchY = null;
          if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) step(dx < 0 ? 1 : -1);
        },
        { passive: true }
      );

      updateCounter();
    });
  }

  /* Numbers marked [data-mm-roman] render as Roman numerals — used for
     the collection hero piece count. */
  function initRomanText(root) {
    (root || document).querySelectorAll('[data-mm-roman]').forEach(function (el) {
      var n = parseInt(el.getAttribute('data-mm-roman'), 10);
      if (n > 0) el.textContent = roman(n);
    });
  }

  /* Collection pagination reads "Page II of IV" — numeric items become
     Roman numerals (aria-labels keep the plain numbers). */
  function romanizePagination(root) {
    (root || document).querySelectorAll('.mm-collection-grid ~ .pagination-wrapper .pagination__item, .collection .pagination__item').forEach(function (item) {
      var text = item.textContent.trim();
      if (/^\d+$/.test(text)) {
        if (!item.getAttribute('aria-label')) {
          item.setAttribute('aria-label', 'Page ' + text);
        }
        item.textContent = roman(parseInt(text, 10));
      }
    });
  }

  /* Facet filtering re-renders the whole product grid container; re-bind
     the reveals, parallax layers and Roman pagination on every change. */
  function initGridRefresh() {
    var container = document.getElementById('ProductGridContainer');
    if (!container || !('MutationObserver' in window)) return;
    new MutationObserver(function () {
      bindReveals(container);
      refreshParallax();
      romanizePagination(container);
    }).observe(container, { childList: true, subtree: true });
  }

  /* Moments day line: the sun glyph travels the horizon as you scroll
     (or as the mobile carousel is swiped). */
  function initMomentsDayline() {
    if (reducedMotion) return;
    var sections = document.querySelectorAll('[data-mm-moments]');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var orb = section.querySelector('[data-mm-orb]');
      var row = section.querySelector('[data-mm-moments-row]');
      if (!orb) return;
      var ticking = false;

      function update() {
        var progress;
        if (row && row.scrollWidth > row.clientWidth + 10) {
          progress = row.scrollLeft / (row.scrollWidth - row.clientWidth);
        } else {
          var rect = section.getBoundingClientRect();
          var vh = window.innerHeight;
          progress = (vh - rect.top) / (vh + rect.height);
        }
        progress = Math.min(Math.max(progress, 0), 1);
        orb.style.left = (6 + progress * 88).toFixed(2) + '%';
        ticking = false;
      }

      function request() {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      }

      window.addEventListener('scroll', request, { passive: true });
      window.addEventListener('resize', request);
      if (row) row.addEventListener('scroll', request, { passive: true });
      update();
    });
  }

  /* Anatomy: hovering a callout dot highlights its ledger entry, and back */
  function initAnatomySync() {
    function setHot(target, on) {
      var origin = target.closest('[data-anatomy-index]');
      if (!origin) return;
      var scope = origin.closest('[data-mm-anatomy]');
      if (!scope) return;
      scope.querySelectorAll('[data-anatomy-index="' + origin.dataset.anatomyIndex + '"]').forEach(function (el) {
        el.classList.toggle('is-hot', on);
      });
    }
    document.addEventListener('mouseover', function (event) {
      if (event.target.closest && event.target.closest('[data-anatomy-index]')) setHot(event.target, true);
    });
    document.addEventListener('mouseout', function (event) {
      if (event.target.closest && event.target.closest('[data-anatomy-index]')) setHot(event.target, false);
    });
    /* touch: a tap toggles the pairing instead */
    document.addEventListener('click', function (event) {
      if (window.matchMedia('(hover: hover)').matches) return;
      var origin = event.target.closest && event.target.closest('[data-anatomy-index]');
      if (!origin) return;
      var scope = origin.closest('[data-mm-anatomy]');
      if (!scope) return;
      var wasHot = origin.classList.contains('is-hot');
      scope.querySelectorAll('.is-hot').forEach(function (el) {
        el.classList.remove('is-hot');
      });
      if (!wasHot) setHot(origin, true);
    });
  }

  /* Namesake monogram: stretch the bridge hairline so it spans exactly
     between the drop lines under the first and last names. */
  function initNamesakeBridge() {
    document.querySelectorAll('.mm-namesake__stage').forEach(function (stage) {
      var bridge = stage.querySelector('.mm-namesake__bridge');
      var cells = stage.querySelectorAll('.mm-namesake__cell');
      if (!bridge || cells.length < 2) return;

      function size() {
        var drop = stage.querySelector('.mm-namesake__drop');
        if (!drop || getComputedStyle(drop).display === 'none') {
          bridge.style.width = '';
          bridge.style.left = '';
          return;
        }
        var stageRect = stage.getBoundingClientRect();
        var first = cells[0].getBoundingClientRect();
        var last = cells[cells.length - 1].getBoundingClientRect();
        var a = first.left + first.width / 2;
        var b = last.left + last.width / 2;
        bridge.style.width = (b - a).toFixed(1) + 'px';
        bridge.style.left = ((a + b) / 2 - (stageRect.left + stageRect.width / 2)).toFixed(1) + 'px';
      }

      size();
      window.addEventListener('resize', size);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(size);
    });
  }

  /* Sticky bar's button proxies the real add-to-cart submit */
  function initStickyBuyProxy() {
    var proxy = document.querySelector('.mm-sticky-buy__btn');
    if (!proxy) return;
    proxy.addEventListener('click', function () {
      var submit = document.querySelector('.product-form__submit');
      if (submit) submit.click();
    });

    /* mirror the real button's availability (Sold out / Unavailable),
       which product-info.js rewrites on every variant change */
    function syncProxy() {
      var submit = document.querySelector('.product-form__submit');
      if (!submit) return;
      if (proxy.disabled !== submit.disabled) proxy.disabled = submit.disabled;
      var label = submit.querySelector('span:not(.loading__spinner):not(.svg-wrapper)');
      var text = (label || submit).textContent.trim();
      /* only write on change; the bar lives inside product-info, so an
         unconditional write would retrigger this observer forever */
      if (text && proxy.textContent.trim() !== text) proxy.textContent = text;
    }

    var form = document.querySelector('product-info');
    if (form && 'MutationObserver' in window) {
      new MutationObserver(syncProxy).observe(form, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled'],
      });
    }
    syncProxy();
  }

  /* Collection rail: bring the current category into view when the rail
     overflows on small screens. */
  function initRailAutoScroll() {
    var current = document.querySelector('.mm-crail__link.is-current');
    if (!current) return;
    var list = current.closest('.mm-crail__list');
    if (!list || list.scrollWidth <= list.clientWidth) return;
    var item = current.closest('.mm-crail__item');
    list.scrollLeft = item.offsetLeft - (list.clientWidth - item.offsetWidth) / 2;
  }

  /* Initials (PDP): personalized pieces carry their letter(s) as a required
     line item property. The product form is novalidate (Dawn submits via
     FormData), so this capture-phase guard stops add-to-cart while the
     field is empty, before product-form.js ever sees the event. Also keeps
     the field uppercase and the counter honest. Delegated, so it survives
     variant re-renders and the quick-add modal.

     Fixed-count pieces ("# of letters: 3") are stricter: the field accepts
     exactly that many letters/numbers, the limit follows the picker live
     (a smaller pick keeps the first letters and says so), and add-to-cart
     waits until the count matches the variant being bought. */
  function initInitialsField() {
    function rootsFor(form) {
      var id = form.getAttribute('id');
      return Array.prototype.filter.call(document.querySelectorAll('[data-mm-initials]'), function (root) {
        var input = root.querySelector('[data-mm-initials-input]');
        return input && input.getAttribute('form') === id;
      });
    }

    function limitOf(root) {
      var n = parseInt(root.getAttribute('data-mm-initials-limit'), 10);
      return n > 0 ? n : 0;
    }

    function unitsFor(root, n) {
      return n === 1 ? root.getAttribute('data-mm-initials-unit') || 'letter' : root.getAttribute('data-mm-initials-units') || 'letters';
    }

    function setInvalid(root, invalid, message) {
      var error = root.querySelector('[data-mm-initials-error]');
      root.classList.toggle('is-invalid', invalid);
      if (!error) return;
      if (invalid && message) error.textContent = message;
      error.hidden = !invalid;
    }

    var noteTimers = new WeakMap();
    function say(root, message) {
      var note = root.querySelector('[data-mm-initials-note]');
      if (!note) return;
      clearTimeout(noteTimers.get(root));
      if (!message) {
        note.hidden = true;
        return;
      }
      note.textContent = message;
      note.hidden = false;
      noteTimers.set(root, setTimeout(function () { note.hidden = true; }, 6000));
    }

    function refresh(root, input) {
      var limit = limitOf(root);
      var length = input.value.trim().length;
      var count = root.querySelector('[data-mm-initials-count]');
      var text = root.querySelector('[data-mm-initials-count-text]') || count;
      if (text) text.textContent = length + ' of ' + (input.getAttribute('maxlength') || '');
      if (count) count.classList.toggle('is-complete', limit > 0 && length === limit);
      root.classList.toggle('is-complete', limit > 0 && length === limit);
      if (length > 0 && (!limit || length === limit)) setInvalid(root, false);
    }

    /* Keep the caret where the shopper left it after we rewrite the value
       (uppercasing, dropping a stray space or symbol). */
    function rewrite(input, value) {
      if (value === input.value) return;
      var caret = input.selectionStart;
      var kept = 0;
      if (typeof caret === 'number') {
        var head = input.value.slice(0, caret);
        kept = tidyText(head, input).length;
      }
      input.value = value;
      try {
        input.setSelectionRange(Math.min(kept, value.length), Math.min(kept, value.length));
      } catch (e) {
        /* some input types refuse selection APIs; the caret lands at the end */
      }
    }

    function tidyText(raw, input) {
      var root = input.closest('[data-mm-initials]');
      var limit = root ? limitOf(root) : 0;
      var value = raw.toUpperCase();
      if (limit > 0) {
        value = value.replace(/[^A-Z0-9]/g, '').slice(0, limit);
      } else {
        value = value.replace(/\s+/g, ' ').replace(/^\s/, '');
      }
      return value;
    }

    function tidy(input) {
      rewrite(input, tidyText(input.value, input));
      var root = input.closest('[data-mm-initials]');
      if (!root) return;
      say(root, '');
      refresh(root, input);
    }

    /* The picker says how many letters the piece is made with; follow it. */
    function setLimit(root, next) {
      next = parseInt(next, 10);
      if (!(next > 0)) return;
      var input = root.querySelector('[data-mm-initials-input]');
      if (!input) return;
      var prev = limitOf(root);
      if (next === prev) return;

      root.setAttribute('data-mm-initials-limit', next);
      input.setAttribute('maxlength', next);
      input.setAttribute('placeholder', 'MCMSFJ'.slice(0, next));

      var hint = root.querySelector('[data-mm-initials-hint]');
      if (hint) {
        hint.textContent =
          next === 1
            ? 'One ' + unitsFor(root, 1) + ' — we make it to order'
            : next + ' ' + unitsFor(root, next) + ', in the order they read';
      }

      /* a smaller pick keeps the first letters — say so, since the shopper
         may be looking at the pills, not the field */
      var before = input.value;
      var after = tidyText(before, input);
      say(root, '');
      if (after !== before) {
        input.value = after;
        if (before.length > next) {
          say(root, 'Now ' + next + ' ' + unitsFor(root, next) + ' — we kept ' + after.split('').join(' ') + '. Edit anytime.');
        }
      }
      refresh(root, input);

      /* an error that was showing should speak about the new count */
      if (root.classList.contains('is-invalid')) {
        var length = input.value.trim().length;
        if (length === next) setInvalid(root, false);
        else setInvalid(root, true, messageFor(root, length, next));
      }
    }

    /* null keeps the Liquid-rendered copy for pieces without a fixed count */
    function messageFor(root, length, limit) {
      if (!(limit > 0)) return null;
      var units = unitsFor(root, limit);
      if (length === 0) {
        return limit > 1 ? 'Tell us your ' + limit + ' ' + units + ' before adding to your bag.' : 'Choose your ' + units + ' before adding to your bag.';
      }
      return 'This piece is made with ' + limit + ' ' + units + ' — you\u2019ve entered ' + length + '.';
    }

    document.addEventListener('input', function (event) {
      if (!event.target.matches || !event.target.matches('[data-mm-initials-input]')) return;
      tidy(event.target);
    });

    /* Picker pills: instant, before Liquid re-renders variant-selects. */
    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.matches || !input.matches('variant-selects input[type="radio"][data-option-name]')) return;
      var formId = input.getAttribute('form');
      document.querySelectorAll('[data-mm-initials][data-mm-initials-option]').forEach(function (root) {
        if (root.getAttribute('data-mm-initials-option') !== input.getAttribute('data-option-name')) return;
        var field = root.querySelector('[data-mm-initials-input]');
        if (formId && field && field.getAttribute('form') !== formId) return;
        setLimit(root, input.value);
      });
    });

    /* Variant change from Dawn (dropdowns, URL-driven selection): confirm
       against the variant's own option value. */
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var data = event && event.data;
        if (!data || !data.variant || !data.variant.options) return;
        var formId = 'product-form-' + data.sectionId;
        document.querySelectorAll('[data-mm-initials][data-mm-initials-option-position]').forEach(function (root) {
          var field = root.querySelector('[data-mm-initials-input]');
          if (field && field.getAttribute('form') !== formId) return;
          var pos = parseInt(root.getAttribute('data-mm-initials-option-position'), 10);
          var value = data.variant.options[pos - 1];
          if (value != null) setLimit(root, value);
        });
      });
    }

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form.getAttribute || form.getAttribute('data-type') !== 'add-to-cart-form') return;
        var blocked = null;
        rootsFor(form).forEach(function (root) {
          var input = root.querySelector('[data-mm-initials-input]');
          input.value = tidyText(input.value, input).trim();
          var limit = limitOf(root);
          var length = input.value.length;
          var short = length === 0 || (limit > 0 && length !== limit);
          if (short) {
            say(root, '');
            setInvalid(root, true, messageFor(root, length, limit));
            if (!blocked) blocked = input;
          } else {
            setInvalid(root, false);
          }
          refresh(root, input);
        });
        if (!blocked) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        blocked.focus({ preventScroll: true });
        var box = blocked.closest('[data-mm-initials]');
        if (box && box.scrollIntoView) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      },
      true
    );
  }

  /* Menu drawer: its own X (inside the fixed overlay) closes through Dawn's
     summary handler so the body unlock, focus return and aria state all run.
     Capture phase, so Dawn's generic in-drawer button listener (which only
     half-closes) never sees the click. */
  function initDrawerClose() {
    document.addEventListener(
      'click',
      function (event) {
        var btn = event.target.closest('[data-mm-drawer-close]');
        if (!btn) return;
        event.preventDefault();
        event.stopPropagation();
        var details = btn.closest('details');
        var summary = details && details.querySelector(':scope > summary');
        if (summary && details.hasAttribute('open')) summary.click();
      },
      true
    );
  }

  function init() {
    initReveals();
    initParallax();
    initHeroSlider();
    initDrawerClose();
    initStickyBuyBar();
    initRailAutoScroll();
    initVariantExtras();
    initInitialsField();
    initEngravingAtelier();
    initStickyBuyProxy();
    initStickyPriceMirror();
    initLightbox();
    initMomentsDayline();
    initNamesakeBridge();
    initAnatomySync();
    updateStickyMeta();
    initRomanText(document);
    romanizePagination(document);
    initGridRefresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
